import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";

/**
 * Genera una columna de DataGrid con icono para abrir el modal de observaciones.
 *
 * @param {Function} showObservationsModal - del hook useObservationsModal()
 * @param {number} componentId - ID del componente origen (control.TAB_COMPONENTS)
 * @param {Object} [options]
 * @param {Function} [options.getCipId] - (row) => cipId. Default: (row) => row.cipId
 * @param {Function} [options.getPatientName] - (row) => name. Default: (row) => row.name || row.memberFullName || ""
 */
export function getObservationsColumn(showObservationsModal, componentId, options = {}) {
  const getCipId = options.getCipId || ((row) => row.cipId);
  const getPatientName = options.getPatientName || ((row) => row.name || row.memberFullName || "");

  return {
    field: "_observations",
    headerName: "",
    width: 40,
    minWidth: 40,
    maxWidth: 40,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: ({ row }) => (
      <Tooltip title="Observations" arrow>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            showObservationsModal(getCipId(row), componentId, getPatientName(row));
          }}
          sx={{
            color: "#8B5CF6",
            "&:hover": { bgcolor: "rgba(139, 92, 246, 0.08)" },
          }}
        >
          <NoteAltOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    ),
  };
}
